import React, {Component} from 'react';
import JVButton from '../components/JVButton';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import queryString from 'query-string';
import FormControl from '@mui/material/FormControl';
import {format} from 'date-fns'
import { withRouter } from 'react-router-dom';
import { CircularProgress,
        Button,
        Dialog,
        DialogActions,
        DialogContentText,
        DialogTitle,
        DialogContent } from '@mui/material';

class Main extends Component {
    constructor(props) {
        // Required step: always call the parent class' constructor
        super(props);

        // Set the state directly. Use props if necessary.
        this.state = {
            totalAvailableTimeSlots: 0,
            totalNumberOfSlotsRequested:0,
            availableTimeSlots: [],
            selectedTimeSlots: [],
            selectedDate:'',
            selectedTimezone:{},
            dateGroup: {},
            activeIndex: 0,
            timezones: window.timezones,
            isLoading: false,
            open: false,
            jobSeekerTimeSlotMessage: ""
        };
    }

    confirmDialog() {
        this.setState({ open: false });
        this.changeTimezoneCommon(this.selectedStoredTimezone);
    }
    handleClose() {
        this.setState({ open: false });
    }

    componentDidMount() {
        const {resData} = this.props;
        const {timezones} = this.state;
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let currentTimezone = null;

        for(let i=0; i<timezones.length; i++){
            if(timezones[i].openSysId === tz){
                currentTimezone = timezones[i];
                this.state.selectedTimezone = timezones[i];
                break;
            }
            if(timezones[i].id === resData.availabilityRequest.timeZoneId.toString()){
                currentTimezone = timezones[i];
                this.state.selectedTimezone = timezones[i];
            }
        }

        let tempTotalAvailableTimeSlots = this.props.resData.availabilityRequest.requestedInterviewSlots.length;
        let tempTotalNumberOfSlotsRequested = this.props.resData.availabilityRequest.numberOfSlots

        this.setState({totalAvailableTimeSlots: tempTotalAvailableTimeSlots});
        this.setState({totalNumberOfSlotsRequested: tempTotalNumberOfSlotsRequested});

        //depending on the number of available slots and total number of slots requested, the message that we show to candidate changes.
        if (tempTotalAvailableTimeSlots >= tempTotalNumberOfSlotsRequested) {
            this.setState({jobSeekerTimeSlotMessage : i18n['JOBSEEKER_TIME_SLOT_NOTE'].replace(/{[0-9]}+/,tempTotalNumberOfSlotsRequested)});
        } else {
            this.setState({jobSeekerTimeSlotMessage : i18n['JOBSEEKER_TIME_SLOT_NOTE_ALTERNATIVE']});
        }

        this.groupByDate(this.props.resData.availabilityRequest.requestedInterviewSlots);

        let dateKeys = Object.keys(this.state.dateGroup);
        if(dateKeys.length > 0){
            this.setState({availableTimeSlots : this.state.dateGroup[dateKeys[0]]});
            this.setState({selectedDate : dateKeys[0].split(' - ')[1]});
        }
    }

    sendAvailabilities = (data, callback) => {
        const values = queryString.parse(window.location.search);
        const companyId = values.c;
        const applicationId = values.appid;
        const requestId = values.requestid;

        const url = window.jvUrls.jobSeeker+'/action/app/interview/availabilityRequest/'+companyId+'/'+applicationId+'/request/'+requestId;
        fetch(url,{
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        .then(result => result.json())
        .then(result => {
            callback(result, this);
        })
    }

    getAvailabilities = (timezoneId, callback) => {
        const values = queryString.parse(window.location.search);
        const companyId = values.c;
        const applicationId = values.appid;
        const requestId = values.requestid;

        const url = window.jvUrls.jobSeeker+'/action/app/interview/availabilityRequest/'+companyId+'/'+applicationId+'/request/'+requestId+'?timezoneId='+timezoneId;
        fetch(url)
        .then(result => result.json())
        .then(result => {
            callback(result, this);
        })
    }

    groupByDate = (list) => {
        let dateGroup = {};

        if(!list){
            return;
        }

        for(let i=0; i<list.length; i++){
            let startDate = new Date(list[i].startStr);
            let endDate = new Date(list[i].endStr);
            let formatDate = format(startDate, 'EEE - MMM dd').toUpperCase();
            let start = format(startDate, 'hh:mm a').toLowerCase();
            let end = format(endDate, 'hh:mm a').toLowerCase();

            let data = {
                startMS: list[i].start,
                endMS: list[i].end,
                start: start,
                end: end,
                active: list[i].active || false
            };

            if(!dateGroup[formatDate]){
                dateGroup[formatDate] = [];
            }

            dateGroup[formatDate].push(data);
        }

        this.state.dateGroup = dateGroup;
        this.setState({dateGroup: dateGroup});
    }

    changeTimezoneMobile = (elem) => {
        const {timezones} = this.state;

        let selectedTimezone = timezones.filter((timezoneObj) => {
            if(timezoneObj.id === elem.target.value){
                return true;
            }
            return false;
        })

        if(this.state.selectedTimeSlots.length > 0 && !confirm(i18n['JOBSEEKER_TIMEZONE_CHANGE'])) {
            return;
        } else {
            this.changeTimezoneCommon(selectedTimezone[0]);
        }
    };

    changeTimezone = (elem) => {
        if(this.state.selectedTimeSlots.length > 0){
            this.selectedStoredTimezone = elem.target.value;
            this.setState({open: true});
        } else {
            this.changeTimezoneCommon(elem.target.value);
        }
    };

    changeTimezoneCommon = (timezone) => {
        const {dateGroup} = this.state;
        let activeIndex = 0;

        this.setState({activeIndex: activeIndex});
        this.setState({isLoading: true});
        this.getAvailabilities(timezone.id, function(result, thisObj){
            thisObj.setState({resData: result});
            thisObj.setState({selectedTimezone : timezone});
            thisObj.groupByDate(result.availabilityRequest.requestedInterviewSlots);

            let dateKeys = Object.keys(thisObj.state.dateGroup);
            if(dateKeys.length > 0){
                thisObj.setState({availableTimeSlots : thisObj.state.dateGroup[dateKeys[activeIndex]]});
                thisObj.setState({selectedDate: dateKeys[activeIndex].split(' - ')[1]});
                thisObj.setState({selectedTimeSlots : []});
            }
            thisObj.setState({isLoading: false});
        });
    }

    selectDate = (data, index) => {
        const {dateGroup} = this.state;

        let dateKeys = Object.keys(dateGroup);
        this.setState({availableTimeSlots : dateGroup[dateKeys[index]]});
        this.setState({activeIndex : index});
        this.setState({selectedDate: dateKeys[index].split(' - ')[1]});
    };

    selectTimeslot = (data, index) => {
        const {availableTimeSlots, selectedTimeSlots} = this.state;

        this.setState({
            availableTimeSlots : availableTimeSlots.filter((dateObj, i) =>{
                if(i === index){
                    let timeIndex = -1;

                    if(dateObj.active){
                        timeIndex = selectedTimeSlots.indexOf(dateObj);
                    }

                    dateObj.active = !dateObj.active;
                    if(dateObj.active){
                        this.setState({selectedTimeSlots:[...this.state.selectedTimeSlots, dateObj]});
                    }else{
                        selectedTimeSlots.splice(timeIndex, 1);
                        this.setState({selectedTimeSlots: selectedTimeSlots});
                    }
                }
                return true;
            })
        })
    };

    submitAvailability = () => {

        const {dateGroup, selectedTimeSlots, totalAvailableTimeSlots, totalNumberOfSlotsRequested} = this.state;

        this.setState({isLoading: true});
        let data = {
            selectedSlots:[]
        };
        selectedTimeSlots.map((timeSlot, index) =>{
            let slot = {
                start: timeSlot.startMS,
                end: timeSlot.endMS
            };

            data.selectedSlots.push(slot);
        });

        this.sendAvailabilities(data, function(res, thisObj){
            const { history } = thisObj.props;
            thisObj.setState({isLoading: false});
            if(res && res.msgInfo === 200){
                history.replace("/success");
            }else{
                history.replace("/fail");
            }
        });
    };

    getLoader = (isLoading) => {
        if(isLoading){
            return(
                <div className="loader">
                    <CircularProgress  className="loaderIcon" />
                </div>
            );
        }else{
            return;
        }
    }

    render() {
        const {resData} = this.props;
        const {availableTimeSlots, selectedTimeSlots, selectedDate, dateGroup, isLoading, jobSeekerTimeSlotMessage} = this.state;
        let dateKeys = Object.keys(dateGroup);

        return (
            <div>
                <div className='content'>
                    <div className='general-width margin-width-auto dark-tri margin-top-x-large margin-bottom-regular'>
                        {jobSeekerTimeSlotMessage}
                    </div>
                    <div className='general-width margin-width-auto media-timezoneSelect clearfix'>
                        <div className='col-12 padding-none'>
                            <div className='col-4 padding-none text-center'>{window['i18n']['TIMEZONE_TEXT']}</div>
                            <FormControl className='col-8 padding-none'>
                                <Select
                                    native
                                    classes={{selectMenu:'small'}}
                                    value={this.state.selectedTimezone.id}
                                    autoWidth={true}
                                    onChange={this.changeTimezoneMobile}
                                    inputProps={{
                                        id: 'Timezone-media'
                                    }}
                                >
                                    { timezones.map((timezone) =>
                                        <option
                                            key={timezone.id}
                                            classes={{root:'small'}}
                                            value={timezone.id}>{timezone.localizedName}
                                        </option>
                                    )}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className='clearfix'>
                        <div className='general-width margin-width-auto margin-bottom-xxx-large dayPicker'>
                            <div className='label'>
                                <label>{window['i18n']['CANDIDATE_PICK_A_DAY'].toUpperCase()}</label>
                            </div>
                            <div className='blue-tri-border-top border-width-2 padding-top-small margin-top-regular'>
                                { dateKeys.map((dateKey, index) =>
                                    <button
                                        key={index}
                                        onClick={ (e) => this.selectDate(dateKey, index) }
                                        className={`btn blue-tri-secondary-btn margin-right-small border-radius-x-large ${this.state.activeIndex === index ? 'active' : ''} padding-top-xx-large padding-bottom-xx-large padding-right-x-large padding-left-x-large`}>
                                            { dateKey.split(' - ').map((item, divKey) => {return <div key={index+''+divKey}>{item}</div>}) }
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className='general-width margin-width-auto timezone-device'>
                            <div className='timezoneSelect'>
                                <span className='margin-right-x-small text-right'>{window['i18n']['TIMEZONE_TEXT']}</span>
                                <FormControl className='selectForm'>
                                    <Select
                                        classes={{selectMenu:'small'}}
                                        value={this.state.selectedTimezone}
                                        autoWidth={true}
                                        onChange={this.changeTimezone}
                                        inputProps={{
                                            name: 'Timezone'
                                        }}
                                    >
                                        {timezones.map((timezone) =>
                                            <MenuItem
                                                key={timezone.id}
                                                classes={{root:'small'}}
                                                value={timezone}>{timezone.localizedName}
                                            </MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className='general-width margin-width-auto timePicker'>
                            <div className='label'><label>{window['i18n']['CANDIDATE_PICK_TIMESLOTS'].toUpperCase().replace(/{[0-9]}+/, selectedDate)}</label></div>
                            <div className='blue-tri-border-top border-width-2 padding-top-small margin-top-regular'>
                                { availableTimeSlots.map((dateKey, index) =>
                                    <button
                                        key={index}
                                        onClick={ (e) => this.selectTimeslot(dateKey, index, e) }
                                        className={`btn green-secondary-btn margin-right-small margin-bottom-small border-radius-x-large ${dateKey.active ? 'active' : ''}`}>
                                            { dateKey.start +' - '+ dateKey.end }
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='floating-object full-width footer'>
                    <div className='general-width margin-width-auto'>
                        <JVButton isDisabled={selectedTimeSlots.length < 1} className='btn blue-btn float-right border-radius-x-large' buttonTitle={window['i18n']['CAND_SUBMIT_AVAILABILITY']} buttonClick={this.submitAvailability} />
                        <label className='dark-pri float-right margin-right-x-large margin-top-x-small'>{window['i18n']['SLOTS_SELECTED'].replace(/{[0-9]}+/, (selectedTimeSlots.length))}</label>
                    </div>
                </div>
                <Dialog open={this.state.open} onClose={this.handleClose.bind(this)} className='dialog_container'>
                    <DialogTitle className='dialog_title'>{window['i18n']['JOBSEEKER_TIMEZONE_CHANGE_DIALOG_TITLE']}</DialogTitle>
                    <DialogContent className='dialog_content'><DialogContentText>{window['i18n']['JOBSEEKER_TIMEZONE_CHANGE']}</DialogContentText></DialogContent>
                    <DialogActions className='dialog_action'>
                        <Button onClick={this.handleClose.bind(this)} variant="contained" className='dialog_action_cancel'>{window['i18n']['JOBSEEKER_TIMEZONE_DIALOG_ACTION_CANCEL']}</Button>
                        <Button onClick={this.confirmDialog.bind(this)} variant="contained" color="primary" autoFocus className='dialog_action_submit'>{window['i18n']['JOBSEEKER_TIMEZONE_DIALOG_ACTION_UNDERSTAND']}</Button>
                    </DialogActions>
                </Dialog>
                {this.getLoader(isLoading)}
            </div>
        );
    }
}
export default withRouter(Main)